import endpoints, { axios } from "../../config/api";

async function getRootFolderTask(projectId: number, taskId: number) {
  return await (
    await axios.get(endpoints.task.getRootFolder(projectId, taskId), {
      maxRedirects: 1
    })
  ).data;
}

export default getRootFolderTask;
